import { useContext, useState } from "react";
import primaryComponents from "../../../primaryComponents";
import { useGetSuppliers } from "../../../../hooks/api/queries";
import secondaryComponents from "../..";
import { useUpdatePO } from "../../../../hooks/api/mutations";
import { ToastContext } from "../../../../hooks/context";

export const UpdateSuplierForm = ({
  po_id,
  supplier_id,
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const [formData, setFormData] = useState({
    supplier_id: supplier_id || "",
  });
  const { data: suppliers, isLoading: isLoadingSupplier } = useGetSuppliers();

  const { mutate: updatePO, isLoading } = useUpdatePO({ id: po_id });
  const handleSupplierUpdate = () => {
    updatePO(
      { id: po_id, data: { ...formData } },
      {
        onSuccess: () => {
          triggerToast("PO supplier updated successfully", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <secondaryComponents.LoaderHelper
      isLoading={isLoadingSupplier}
      classNames={"mt-5"}
    >
      <div>
        <primaryComponents.SelectField
          label={"Supplier"}
          idKey={"id"}
          nameKey={"name"}
          options={suppliers}
          value={
            suppliers?.find(
              (supplier) => `${supplier?.id}` === `${formData?.supplier_id}`,
            )?.name || "Select supplier"
          }
          onChange={(value) => {
            setFormData((prevState) => ({
              ...prevState,
              supplier_id: value,
            }));
          }}
        />

        <primaryComponents.Button
          classNames={"btn btn--primary cover mt-2"}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Updating..."}
          onClick={() => handleSupplierUpdate()}
        >
          Update Supplier
        </primaryComponents.Button>
      </div>
    </secondaryComponents.LoaderHelper>
  );
};
